<mat-card>
  <app-card-header
    icono="hub"
    [title]="title"
    [subtitle]="subtitle"
    [draggable]="!!dialogRef"
  ></app-card-header>

  @if (form && !loading) {
    <form [formGroup]="form" autocomplete="off" (ngSubmit)="onSubmit()">
      <!-- Content -->
      <mat-card-content class="card-content-crear">
        <!-- Sección: Entidad / Agrupación -->
        <app-content-card title="Agrupación" icon="hub">
          <section class="inputs-group">
            <!-- Estado: activa / desactivada -->
            <div class="toggle-hint-row">
              <mat-slide-toggle formControlName="activo" color="primary">
                Configuración activa
              </mat-slide-toggle>
              <small class="ayuda">
                Desactivada, la configuración se conserva pero no se reenvía
                nada. Se puede crear apagada y activarla más tarde.
              </small>
            </div>
          </section>

          <section class="inputs-group">
            <!-- Selector de agrupación -->
            <ng-select
              [items]="agrupacionesReenvio"
              formControlName="agrupacionReenvio"
              placeholder="Agrupación"
              appendTo="body"
              notFoundText="Sin resultados"
              style="width: 100%"
            ></ng-select>

            <!-- Selector tipo de entidad -->
            @if (form?.value?.agrupacionReenvio === 'Entidad') {
              <ng-select
                [items]="tiposEntidades"
                formControlName="tipoEntidad"
                placeholder="Tipo"
                appendTo="body"
                notFoundText="Sin resultados"
                style="width: 100%"
              ></ng-select>
            }

            <!-- Trackers -->
            @if (
              form?.value?.tipoEntidad === 'Tracker' &&
              form?.value?.agrupacionReenvio === 'Entidad'
            ) {
              <div style="width: 100%">
                <ng-select
                  [items]="trackers"
                  bindLabel="nombre"
                  bindValue="_id"
                  formControlName="idEntidadReenvio"
                  placeholder="Tracker"
                  [notFoundText]="'No hay Trackers'"
                  style="width: 100%"
                  multiple="false"
                  searchable="true"
                  appendTo="body"
                ></ng-select>
              </div>
            }

            <!-- Vehículos -->
            @if (
              form?.value?.tipoEntidad === 'Vehículo' &&
              form?.value?.agrupacionReenvio === 'Entidad'
            ) {
              <div style="width: 100%">
                <ng-select
                  [items]="vehiculos"
                  bindLabel="identificacion"
                  bindValue="_id"
                  [searchFn]="buscarVehiculo"
                  formControlName="idEntidadReenvio"
                  placeholder="Vehículo"
                  [notFoundText]="'No hay Vehículos'"
                  style="width: 100%"
                  multiple="false"
                  searchable="true"
                  appendTo="body"
                ></ng-select>
              </div>
            }

            <!-- Alarmas -->
            @if (
              form?.value?.tipoEntidad === 'Alarma' &&
              form?.value?.agrupacionReenvio === 'Entidad'
            ) {
              <div style="width: 100%">
                <ng-select
                  [items]="alarmas"
                  bindLabel="nombre"
                  bindValue="_id"
                  formControlName="idEntidadReenvio"
                  placeholder="Alarma"
                  [notFoundText]="'No hay Alarmas'"
                  style="width: 100%"
                  multiple="false"
                  searchable="true"
                  appendTo="body"
                ></ng-select>
              </div>
            }

            <!-- Clientes + Reenviar hijos -->
            @if (form?.value?.agrupacionReenvio !== 'Entidad') {
              <app-cliente-selector
                formControlName="idClienteReenvio"
                style="width: 100%"
              ></app-cliente-selector>
            }
          </section>

          @if (form?.value?.agrupacionReenvio !== 'Entidad') {
            <section class="inputs-group">
              <div class="toggle-hint-row">
                <mat-slide-toggle
                  formControlName="reenviarHijos"
                  color="primary"
                >
                  Reenviar a hijos
                </mat-slide-toggle>
                <small class="ayuda">
                  Si está activado, los eventos de los dispositivos hijos
                  también serán reenviados
                </small>
              </div>
            </section>
          }
        </app-content-card>

        <!-- Sección: Opciones de Reenvío -->
        <app-content-card title="Opciones de reenvío" icon="forward_to_inbox">
          <!-- Subsección: Método -->
          <section class="inputs-group" style="flex-direction: column">
            <!-- Selector de método -->
            <div [formGroup]="opcionesReenvio" style="width: 100%">
              <ng-select
                [items]="metodosReenvio"
                formControlName="metodo"
                placeholder="Método de reenvío"
                [clearable]="false"
                appendTo="body"
                notFoundText="Sin resultados"
                style="width: 100%"
              ></ng-select>
              <small class="ayuda">
                @if (form?.value?.opcionesReenvio?.metodo === 'Básico') {
                  Se reenvía el mensaje tal como se recibe
                }
                @if (
                  form?.value?.opcionesReenvio?.metodo ===
                  'Seguridad Evento Externo'
                ) {
                  Envía los eventos a la APP de seguridad para activar sirenas
                  y/o generar alertas
                }
                @if (form?.value?.opcionesReenvio?.metodo === 'Caessat') {
                  Reenvía a Caessat
                }
                @if (form?.value?.opcionesReenvio?.metodo === 'Cersat') {
                  Reenvía a Cersat
                }
                @if (form?.value?.opcionesReenvio?.metodo === 'Iron Tracking') {
                  Envía posiciones y eventos al sistema Iron Tracking de Recurso
                  Confiable vía SOAP
                }
                @if (form?.value?.opcionesReenvio?.metodo === 'Logictracker') {
                  Reenvía a Logictracker vía HTTP
                }
                @if (form?.value?.opcionesReenvio?.metodo === 'Soflex') {
                  Reenvía a Soflex
                }
                @if (form?.value?.opcionesReenvio?.metodo === 'Objetivo AVL') {
                  Reenvía posiciones a Policía de la Ciudad durante una
                  emergencia declarada. La URL y el token salen del cliente
                  (Configuración Objetivos AVL)
                }
              </small>
            </div>

            <!-- Opciones: BÁSICO -->
            @if (form?.value?.opcionesReenvio?.metodo === 'Básico') {
              <div style="width: 100%" [formGroup]="opcionesReenvio">
                <div class="toggle-hint-row">
                  <mat-slide-toggle
                    formControlName="usaReglaReenvio"
                    color="primary"
                  >
                    Usar regla de reenvío
                  </mat-slide-toggle>
                  <small class="ayuda">
                    Si está activado, podés definir reglas específicas según
                    puertos y protocolos de entrada. Sino, se reenviará el
                    mensaje tal como llega.
                  </small>
                </div>

                @if (!form?.value?.opcionesReenvio?.usaReglaReenvio) {
                  <div class="fila-campos" style="margin-top: 12px">
                    <mat-form-field style="flex: 7">
                      <mat-label>Host</mat-label>
                      <input matInput formControlName="host" />
                      <mat-icon matPrefix>dns</mat-icon>
                    </mat-form-field>
                    <mat-form-field style="flex: 3">
                      <mat-label>Puerto</mat-label>
                      <input matInput formControlName="puerto" type="number" />
                      <mat-icon matPrefix>tag</mat-icon>
                    </mat-form-field>
                  </div>
                }

                @if (form?.value?.opcionesReenvio?.usaReglaReenvio) {
                  <div class="reglas">
                    @if (reglasReenvio && reglasReenvio.length > 0) {
                      <div class="reglas-table-wrapper">
                        <table class="reglas-table">
                          <thead>
                            <tr>
                              <th>Puerto entrada</th>
                              <th>Protocolo entrada</th>
                              <th>Host salida</th>
                              <th class="col-puerto">Puerto salida</th>
                              <th class="col-protocolo">Protocolo salida</th>
                            </tr>
                          </thead>
                          <tbody>
                            @for (
                              regla of reglasReenvio.controls;
                              track $index;
                              let i = $index
                            ) {
                              <tr [formGroup]="$any(regla)">
                                <td>
                                  <div class="readonly-field">
                                    {{
                                      getNombrePuerto(
                                        regla.get('puertoEntrada')?.value,
                                        regla.get('protocoloEntrada')?.value
                                      )
                                    }}
                                    ({{ regla.get('puertoEntrada')?.value }})
                                  </div>
                                </td>
                                <td>
                                  <div class="readonly-field">
                                    {{ regla.get('protocoloEntrada')?.value }}
                                  </div>
                                </td>
                                <td>
                                  <mat-form-field subscriptSizing="dynamic">
                                    <input
                                      matInput
                                      formControlName="hostSalida"
                                      placeholder="Host"
                                    />
                                  </mat-form-field>
                                </td>
                                <td>
                                  <mat-form-field subscriptSizing="dynamic">
                                    <input
                                      matInput
                                      formControlName="puertoSalida"
                                      type="number"
                                      placeholder="Puerto"
                                    />
                                  </mat-form-field>
                                </td>
                                <td>
                                  <ng-select
                                    [items]="protocolos"
                                    bindValue="valor"
                                    bindLabel="etiqueta"
                                    formControlName="protocoloSalida"
                                    placeholder="Protocolo"
                                    appendTo="body"
                                    notFoundText="Sin resultados"
                                  ></ng-select>
                                </td>
                              </tr>
                            }
                          </tbody>
                        </table>
                      </div>
                    }
                    @if (!reglasReenvio || reglasReenvio.length === 0) {
                      <app-empty-state
                        title="Sin reglas"
                        description="No hay reglas de reenvío configuradas"
                      ></app-empty-state>
                    }
                  </div>
                }
              </div>
            }

            <!-- Opciones: SEGURIDAD EVENTO EXTERNO -->
            @if (
              form?.value?.opcionesReenvio?.metodo ===
              'Seguridad Evento Externo'
            ) {
              <mat-form-field [formGroup]="opcionesReenvio" style="width: 100%">
                <mat-label>Api Key</mat-label>
                <input matInput formControlName="apikey" />
                <mat-icon matPrefix>key</mat-icon>
              </mat-form-field>
            }

            <!-- Opciones: CAESSAT / CERSAT -->
            @if (
              form?.value?.opcionesReenvio?.metodo === 'Caessat' ||
              form?.value?.opcionesReenvio?.metodo === 'Cersat'
            ) {
              <div [formGroup]="opcionesReenvio" class="fila-campos">
                <mat-form-field style="flex: 4">
                  <mat-label>Host</mat-label>
                  <input matInput formControlName="host" />
                  <mat-icon matPrefix>dns</mat-icon>
                </mat-form-field>
                <mat-form-field style="flex: 2.5">
                  <mat-label>Puerto</mat-label>
                  <input matInput formControlName="puerto" type="number" />
                  <mat-icon matPrefix>tag</mat-icon>
                </mat-form-field>
                <ng-select
                  [items]="protocolos"
                  bindValue="valor"
                  bindLabel="etiqueta"
                  formControlName="protocolo"
                  placeholder="Protocolo"
                  [clearable]="false"
                  appendTo="body"
                  notFoundText="Sin resultados"
                  style="flex: 3.5"
                ></ng-select>
              </div>
            }

            <!-- Opciones: IRON TRACKING -->
            @if (form?.value?.opcionesReenvio?.metodo === 'Iron Tracking') {
              <div [formGroup]="opcionesReenvio" style="width: 100%">
                <div class="fila-campos">
                  <mat-form-field style="flex: 1">
                    <mat-label>Usuario</mat-label>
                    <input matInput formControlName="usuario" />
                    <mat-icon matPrefix>person</mat-icon>
                  </mat-form-field>
                  <mat-form-field style="flex: 1">
                    <mat-label>Contraseña</mat-label>
                    <input
                      matInput
                      formControlName="contrasena"
                      type="password"
                    />
                    <mat-icon matPrefix>lock</mat-icon>
                  </mat-form-field>
                </div>
                <mat-form-field style="width: 100%; margin-top: 12px">
                  <mat-label>Endpoint</mat-label>
                  <input matInput formControlName="host" />
                  <mat-icon matPrefix>link</mat-icon>
                  <mat-hint>
                    Dejar vacío para usar el endpoint de producción de RC
                  </mat-hint>
                </mat-form-field>
              </div>
            }

            <!-- Opciones: LOGICTRACKER -->
            @if (form?.value?.opcionesReenvio?.metodo === 'Logictracker') {
              <div [formGroup]="opcionesReenvio" class="fila-campos">
                <mat-form-field style="flex: 7">
                  <mat-label>Host</mat-label>
                  <input matInput formControlName="host" />
                  <mat-icon matPrefix>dns</mat-icon>
                </mat-form-field>
                <mat-form-field style="flex: 3">
                  <mat-label>Puerto</mat-label>
                  <input matInput formControlName="puerto" type="number" />
                  <mat-icon matPrefix>tag</mat-icon>
                </mat-form-field>
              </div>
            }

            <!-- Opciones: SOFLEX -->
            @if (form?.value?.opcionesReenvio?.metodo === 'Soflex') {
              <div style="width: 100%">
                <div [formGroup]="opcionesSoflex" class="fila-campos">
                  <mat-form-field style="flex: 1">
                    <mat-label>Provider ID</mat-label>
                    <input matInput formControlName="providerid" />
                    <mat-icon matPrefix>fingerprint</mat-icon>
                  </mat-form-field>
                  <mat-form-field style="flex: 1">
                    <mat-label>Versión</mat-label>
                    <input matInput formControlName="version" />
                    <mat-icon matPrefix>new_releases</mat-icon>
                    <mat-hint>vX.X</mat-hint>
                  </mat-form-field>
                </div>
                <div
                  [formGroup]="opcionesReenvio"
                  class="fila-campos"
                  style="margin-top: 12px"
                >
                  <mat-form-field style="flex: 1">
                    <mat-label>Usuario</mat-label>
                    <input matInput formControlName="usuario" />
                    <mat-icon matPrefix>person</mat-icon>
                  </mat-form-field>
                  <mat-form-field style="flex: 1">
                    <mat-label>Contraseña</mat-label>
                    <input
                      matInput
                      formControlName="contrasena"
                      type="password"
                    />
                    <mat-icon matPrefix>lock</mat-icon>
                  </mat-form-field>
                  <mat-form-field style="flex: 2">
                    <mat-label>Host</mat-label>
                    <input matInput formControlName="host" />
                    <mat-icon matPrefix>dns</mat-icon>
                  </mat-form-field>
                </div>

                <!-- Test de la configuración (no envía nada a Soflex) -->
                <div class="test-soflex-row">
                  <button
                    irxBoton="secundario"
                    type="button"
                    (click)="probarConfigSoflex()"
                  >
                    <mat-icon>fact_check</mat-icon>
                    Probar configuración
                  </button>
                  <small class="ayuda">
                    Muestra qué vehículos se reenviarían, los fleetId resueltos
                    y qué datos faltan para crearlos en Soflex. No envía nada a
                    Soflex.
                  </small>
                </div>
              </div>
            }

            <!-- Opciones: OBJETIVO AVL -->
            @if (form?.value?.opcionesReenvio?.metodo === 'Objetivo AVL') {
              <div style="width: 100%">
                <div [formGroup]="opcionesObjetivoAVL" class="fila-campos">
                  <mat-form-field style="flex: 1">
                    <mat-label>Device ID</mat-label>
                    <input matInput formControlName="deviceid" />
                    <mat-icon matPrefix>fingerprint</mat-icon>
                    <mat-hint>
                      Tiene que ser idéntico al que el operador cargó al
                      declarar la emergencia en e911
                    </mat-hint>
                  </mat-form-field>
                  <mat-form-field style="flex: 1">
                    <mat-label>Nro. de Carta Policial</mat-label>
                    <input matInput formControlName="nroCarta" />
                    <mat-icon matPrefix>assignment</mat-icon>
                    <mat-hint>Opcional, para trazabilidad</mat-hint>
                  </mat-form-field>
                </div>
                <small class="ayuda">
                  Cargá el período de reenvío más abajo: al vencer, el envío se
                  corta solo.
                </small>
              </div>
            }
          </section>
        </app-content-card>

        <!-- Sección: Período -->
        <app-content-card title="Período" icon="date_range">
          <section class="inputs-group">
            <div style="width: 100%">
              <app-date-range-selector
                style="width: 100%"
                [dateRange]="range"
                (dateRangeChange)="onRangeChange($event)"
                [maxDate]="null"
                [placeholder]="'Período de reenvío'"
              ></app-date-range-selector>
              <small class="ayuda">
                Si no se define un período, los reenvíos se realizan de manera
                continua e indefinida.
              </small>
            </div>
          </section>
        </app-content-card>
      </mat-card-content>

      <!-- Botones -->
      <mat-card-actions class="actions-create">
        <button irxBoton="secundario" type="button" (click)="volver()">
          Cancelar
        </button>
        <button
          irxBoton="principal"
          type="submit"
          [disabled]="!form.valid || loading"
        >
          <mat-icon>save</mat-icon>
          {{ id ? 'Guardar' : 'Crear' }}
        </button>
      </mat-card-actions>
    </form>
  } @else {
    <mat-card-content class="card-content-crear">
      <section class="inputs-group">
        <app-loading
          text="Cargando formulario..."
          [diameter]="60"
        ></app-loading>
      </section>
    </mat-card-content>
  }
</mat-card>
